import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, MapPin, Clock } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { API } from "../config";
import Footer from "./components/Footer";

export default function ContactPage() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try { await axios.post(`${API}/contact`, formData); toast.success('Üzenet sikeresen elküldve!'); setFormData({ name: '', email: '', subject: '', message: '' }); }
    catch (error) { toast.error('Hiba történt'); }
    finally { setIsSubmitting(false); }
  };

  return (
    <div data-testid="contact-page">
      <div className="min-h-screen pt-24 sm:pt-32 pb-32 px-4 sm:px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto">
        <div className="mb-8 sm:mb-16 animate-fade-in">
          <p className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-primary mb-2 sm:mb-4">Lépj kapcsolatba</p>
          <h1 className="text-3xl sm:text-5xl font-bold font-['Syne'] tracking-tighter">Kapcsolat</h1>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-16">
          <div className="animate-fade-in stagger-1">
            <h2 className="text-xl font-bold font-['Syne'] mb-4">Írj nekem</h2>
            <p className="text-muted-foreground text-sm mb-6">Fellépés szervezés, sajtómegkeresés vagy csak üzenni szeretnél? Szívesen várom a leveledet!</p>
            <div className="space-y-4">
              <div className="flex items-center gap-4"><div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center"><Mail className="h-4 w-4 text-primary" /></div><div><p className="text-xs text-muted-foreground">Email</p><p className="font-medium text-sm">zoltan@ztmusics.hu</p></div></div>
              <div className="flex items-center gap-4"><div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center"><MapPin className="h-4 w-4 text-primary" /></div><div><p className="text-xs text-muted-foreground">Helyszín</p><p className="font-medium text-sm">Budapest, Magyarország</p></div></div>
              <div className="flex items-center gap-4"><div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center"><Clock className="h-4 w-4 text-primary" /></div><div><p className="text-xs text-muted-foreground">Válaszidő</p><p className="font-medium text-sm">48 órán belül</p></div></div>
            </div>
          </div>
          <div className="glass rounded-xl p-4 sm:p-8 animate-fade-in stagger-2">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div><label className="text-xs font-medium mb-2 block">Név</label><Input value={formData.name} onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))} placeholder="Neved" required className="bg-black/40 border-white/10 h-10 rounded-lg text-sm" /></div>
              <div><label className="text-xs font-medium mb-2 block">Email</label><Input type="email" value={formData.email} onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))} placeholder="email@pelda.hu" required className="bg-black/40 border-white/10 h-10 rounded-lg text-sm" /></div>
              <div><label className="text-xs font-medium mb-2 block">Tárgy</label><Input value={formData.subject} onChange={(e) => setFormData(prev => ({ ...prev, subject: e.target.value }))} placeholder="Miről szeretnél írni?" required className="bg-black/40 border-white/10 h-10 rounded-lg text-sm" /></div>
              <div><label className="text-xs font-medium mb-2 block">Üzenet</label><Textarea value={formData.message} onChange={(e) => setFormData(prev => ({ ...prev, message: e.target.value }))} placeholder="Írd ide az üzeneted..." required rows={4} className="bg-black/40 border-white/10 rounded-lg resize-none text-sm" /></div>
              <Button type="submit" disabled={isSubmitting} className="w-full h-10 rounded-full bg-primary hover:bg-primary/90 font-bold text-sm">{isSubmitting ? 'Küldés...' : 'Üzenet küldése'}</Button>
            </form>
          </div>
        </div>
      </div>
      </div>
      <Footer />
    </div>
  );
}
